<template>
    <main class="products-list-container">
        <section class="product-tags-main">
            <div class="tags-title">篩選</div>
            <div class="tags-main">
                <el-input placeholder="Search..." v-model="productName" class="search-input">
                    <el-button slot="append" icon="el-icon-search" size="small" @click="getProductList"></el-button>
                </el-input>
                <div class="tag-group" v-for="item in tagCategory" :key="item.categoryId">
                    <p class="group-name">{{ fieldValue(item, 'categoryName') }} ({{ item.merchantProductTags.length }})</p>
                    <div class="tag-category">
                        <el-checkbox-group v-model="tagList" @change="debouncedDoSearch" :disabled="loading">
                            <el-checkbox v-for="tag in item.merchantProductTags" :key="tag.id" :label="tag.id">
                                {{ fieldValue(tag,'name') }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </div>
        </section>
        <section class="product-list-main">
            <div class="produt-total">{{ search.total }} 個結果</div>
            <div class="product-list">
                <section class="product-list" v-if="!loading">
                    <div class="list-item-main" v-for="item in products" :key="item.id" @click="goShoppingCart(item)">
                        <div class="product-info">
                            <div class="product-img">
                                <img style="width: 100%;" :src="item.coverImage ? `https://order.cateraway.com/api/file/image/${item.coverImage}` : $defaultImg"/>
                            </div>
                            <div class="product-body">
                                <p class="product-name">{{ fieldValue(item, 'name') }}</p>
                                <span class="discount-price"></span>
                                <span :class="['product-price']"></span>
                            </div>
                        </div>
                    </div>
                </section>
                <el-skeleton class="list-item-main" v-else  animated v-for="item in 8" :key="item">
                    <template slot="template">
                        <el-skeleton-item variant="image" style="width: 240px; height: 240px;" />
                        <div style="padding: 14px;">
                            <el-skeleton-item variant="p" style="width: 50%" />
                                <div style="display: flex; align-items: center; justify-items: space-between;">
                                <el-skeleton-item variant="text" style="margin-right: 16px;" />
                                <el-skeleton-item variant="text" style="width: 30%;" />
                            </div>
                        </div>
                    </template>
                </el-skeleton>
            </div>
            <el-pagination class="pagination" v-if="search.total > 0" layout="prev, pager, next" background :page-size="search.pageSize" :current-page="search.pageNumber" :total="search.total" @current-change="handleCurrentChange" />
        </section>
        <ImagePopup :data="current" v-if="menuPopup" @closed="menuPopup=false,current={}"></ImagePopup>
    </main>
</template>

<script>
import productApi from "../../../../api/product"
import { debounce } from "../../../../utils";
import ImagePopup from "./ImagePopup.vue";
export default {
    components:{
        ImagePopup
    },
    data() {
        return {
            search:{
                pageNumber: 1,
                pageSize: 12,
                total:0,
            },
            productName:'',
            products:[],
            tagCategory:[],
            tagList:[],
            loading:false,
            visible:true,
            menuPopup:false,
            images:[],
            current:{}
        }
    },
    computed:{
        fieldValue(){
            return (item, field) => {
                if (!item || !field) return ''
                let lang = this.$i18n.locale
                if (lang === "zh") {
                    return item[field + "Zh"]
                }
                return item[field + 'En']
            }
        },
        debouncedDoSearch() {
            return debounce(this.getProductList, 300); // 设置延迟时间为300毫秒
        },
    },
    mounted(){
        this.getProductTags()
        this.getProductList()
    },
    methods:{
        goShoppingCart(data){
            if (!data.id || data.id === '') return
            if (data.menuImage) {
                this.current = data
                this.images = [data.menuImage]
                this.menuPopup = true
            } else {
                window.open(`https://order.cateraway.com/product?id=${data.id}`,'_blank')
            }
        },
        getProductTags(){
            productApi.productTags('0da8d60a138edba7918a6517ccd49c9c').then(result => {
                this.tagCategory = result.data.filter(item => item.merchantProductTags && item.merchantProductTags.length > 0)
            })
        },
        getProductList() {
            let query = { 
                ...this.search,
                tags:this.tagList
            }
            query[this.$i18n.locale === 'zh' ? 'queryZh' : 'queryEn'] = this.productName
            if (this.loading) return
            this.loading = true
            productApi.productList(query,'0da8d60a138edba7918a6517ccd49c9c').then(result => {
                const { data,total } = result
                this.products = data;
                this.search = {...this.search,total:Number(total)}
            }).finally(() => {
                this.loading = false
            })
        },
        handleCurrentChange(value){
            this.search.pageNumber = value
            this.getProductList()
        },
    }
}
</script>

<style lang="less" scoped>
.products-list-container {
    margin: auto;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    padding: 0 10px;
    @media (max-width: 850px) {
        flex-direction: column;
    }
    .product-tags-main {
        width: 100%;
        height: 100%;
        max-width: 285px;
        border-radius: 5px;
        color: #000;
        font-family: 'Noto Sans TC', sans-serif;
        border: 1px solid #dee2e6;
        @media (max-width: 850px) {
            max-width: 100%;
        }
        .tags-title {
            padding: 15px;
            color: #ff5809;
            border-bottom: 1px solid #dee2e6;
        }
        .tags-main {
            padding: 15px;
            .search-input{
                margin-bottom: 10px;
                border-radius: 5px;
                .el-input__inner {
                    border-radius: 0px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                }
                .el-input-group__append {
                    border-radius: 0px;
                    border-top-right-radius: 5px;
                    border-bottom-right-radius: 5px;
                    background: #f59003;
                    color: #fff;
                }
            }
            .tag-group {
                padding: 8px;
                .group-name {
                    font-family: 'Noto Sans TC', sans-serif;
                    font-weight: 700;
                    margin-bottom: 15px;
                }
                .tag-category {
                    max-height: 45vh;
                    overflow: scroll;
                    border-radius: 2px;
                    border: 1px solid #dee2e6;
                    padding: 10px 10px;
                    border-radius: 5px;
                    /deep/ .el-checkbox-group {
                        .el-checkbox ~ .el-checkbox {
                            margin-top: 10px;
                        }
                        .el-checkbox {
                            display: flex;
                            flex-direction: row-reverse;
                            justify-content: space-between;
                            width: 100%;
                            height: auto;
                            margin-right: 0;
                            .el-checkbox__label {
                                padding-left: 0;
                                margin-right: 5px;
                                font-size: 14px;
                                font-weight: 700;
                                color: #000;
                                white-space: normal;
                                line-height: 1.75;
                                font-family: 'Noto Sans TC', sans-serif
                            }
                            .el-checkbox__input {
                                .el-checkbox__inner {
                                    width: 20px;
                                    height: 20px;
                                    background: #fff;
                                    border-radius: 3px;
                                    border: 2px solid #484848;
                                    font-family: 'Noto Sans TC', sans-serif;
                                    &::after {
                                        border-width: 2px;
                                        border-color: #f59003;
                                        left: 6px;
                                        height: 9px;
                                        top: 2px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .product-list-main {
        max-width: 1140px;
        flex: 1;
        .produt-total {
            padding: 0 15px;
            font-size: .875rem;
            font-weight: 700;
            font-family: 'Noto Sans TC', sans-serif;
            margin-bottom: 15px;
        }
        .product-list {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            .list-item-main {
                padding: 0px 15px 15px 20px;
                flex: 0 0 33.33%;
                max-width: 285px;
                border-radius: 5px;
                @media (max-width: 1200px) {
                    flex: 0 0 50%;
                }
                @media (max-width: 768px) {
                    padding: 0px 5px 10px;
                }
                @media (max-width: 375px) {
                    flex: 0 0 100%;
                }
                .product-info {
                    height: 100%;
                    cursor: pointer;
                    box-shadow: 0 4px 20px #5E5050;
                    transition: all .2s ease;
                    border-radius: 5px;
                    &:hover {
                        transform: translateY(-4px);
                    }
                    .product-img {
                        width: 100%;
                        height: 200px;
                        border-radius: 5px;
                        overflow: hidden;
                        border-bottom: 1px solid #eee;
                        object-fit: contain;
                        img {
                            border-radius: 5px;
                        }
                    }
                    .product-body {
                        padding: 15px;
                        font-size: 16px;
                        .product-name {
                            margin-bottom: 10px;
                            font-weight: 500;
                        }
                        .discount-price {
                            font-weight: 700;
                            margin-right: 10px;
                        }
                        .product-price {
                            font-weight: 700;
                            &.origin-price {
                                font-size: 12px;
                                font-weight: 500;
                                text-decoration: line-through;
                            }
                        }
                    }
                }
            }
        }
        /deep/ .el-pagination {
            text-align: center;
            .btn-prev,
            .btn-next {
                background: none;
            }
            .el-pager {
                .number {
                    border-radius: 50%;
                    &.active {
                        background: #f59003;
                    }
                }
            }
        }
    }
}
</style>
